import React from 'react';
import { Reveal } from './Reveal';
const stats = [['300+', 'PRINTABLE PAGES'], ['5', 'COMPLETE VOLUMES'], ['10,000+', 'HAPPY TEACHERS'], ['ZERO', 'PREP REQUIRED']];
export function StatsBar() {
  return <section className="border-y border-brand-dark bg-brand-alt py-8" data-id="element-147" data-mp="1oacb1v26l799">
      <Reveal className="mx-auto grid max-w-5xl grid-cols-2 gap-y-8 px-4 text-center md:grid-cols-4 md:gap-8" data-id="element-148" data-mp="1jckegnqlcwyq">
        {stats.map(([value, label], index) => <div key={label} className={`flex flex-col items-center justify-center ${index > 0 ? 'md:border-l md:border-brand-dark' : ''}`} data-id="element-149" data-mp="1eein7fj0hrc6" data-mpi={index}>
          <span className="mb-1 font-serif text-3xl font-bold text-brand-blue md:text-4xl" data-id="element-150" data-mp="15kxb63y8eo6g">{value}</span>
          <span className="text-[10px] font-bold uppercase tracking-wider text-brand-gray md:text-xs" data-id="element-151" data-mp="10m2t548393ne">{label}</span>
        </div>)}
      </Reveal>
    </section>;
}